import { Transform } from "class-transformer";
import {
  IsEnum,
  IsISO8601,
  IsInt,
  IsOptional,
  IsString,
  Max,
  Min,
} from "class-validator";

export enum ContractorMatchSortBy {
  MATCHED_TS = "matchedTs",
  CLIENT_NAME = "clientName",
  ADDRESS = "address",
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export class FindContractorMatchesDto {
  @IsOptional()
  @IsInt()
  @Min(1)
  @Transform(({ value }: { value: unknown }) =>
    value !== undefined ? parseInt(String(value), 10) : value,
  )
  page?: number;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Max(100)
  @Transform(({ value }: { value: unknown }) =>
    value !== undefined ? parseInt(String(value), 10) : value,
  )
  limit?: number;

  @IsOptional()
  @IsString()
  search?: string;

  @IsOptional()
  @IsISO8601()
  dateFrom?: string;

  @IsOptional()
  @IsISO8601()
  dateTo?: string;

  @IsOptional()
  @IsEnum(ContractorMatchSortBy)
  sortBy?: ContractorMatchSortBy;

  @IsOptional()
  @IsEnum(SortDirection)
  @Transform(({ value }) => value?.toUpperCase())
  sortDirection?: SortDirection;
}
